/*
 * Accessibility enhancement: closes desktop nav dropdowns/mega-menus once
 * keyboard focus has moved past their last link, so a menu can't be left
 * open and covering the page after a keyboard user tabs away from it.
 *
 * Additive only — doesn't touch or depend on however the theme's own
 * script/CSS opens these menus (:hover, :focus-within, or JS). It force-
 * hides a dropdown only once focus has genuinely left it, and clears
 * that override the moment focus or the mouse returns, so normal mouse
 * hover behavior is unaffected.
 */
(function () {
  'use strict';

  var DROPDOWN_ITEM_SELECTOR = '.site-nav--has-dropdown, .site-nav--is-megamenu';
  var FORCE_CLOSE_CLASS = 'a11y-force-close';

  var style = document.createElement('style');
  style.textContent =
    '.' + FORCE_CLOSE_CLASS + ' .site-nav__dropdown,' +
    '.' + FORCE_CLOSE_CLASS + ' .megamenu {' +
    '  display: none !important;' +
    '}';
  document.head.appendChild(style);

  function closeItem(li) {
    li.classList.add(FORCE_CLOSE_CLASS);
  }

  function reopenItem(li) {
    li.classList.remove(FORCE_CLOSE_CLASS);
  }

  document.addEventListener(
    'focusout',
    function (e) {
      var li = e.target.closest ? e.target.closest(DROPDOWN_ITEM_SELECTOR) : null;
      if (!li) {
        return;
      }
      window.setTimeout(function () {
        var active = document.activeElement;
        if (!active || !li.contains(active)) {
          closeItem(li);
        }
      }, 0);
    },
    true
  );

  document.addEventListener('focusin', function (e) {
    var li = e.target.closest ? e.target.closest(DROPDOWN_ITEM_SELECTOR) : null;
    if (li) {
      reopenItem(li);
    }
  });

  document.addEventListener('mouseover', function (e) {
    var li = e.target.closest ? e.target.closest(DROPDOWN_ITEM_SELECTOR) : null;
    if (li) {
      reopenItem(li);
    }
  });
})();
